import { createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { RequestForQuoteFormModel } from "@tCooneyBrothers/ApiModels";
import { addRequestForQuoteFormFields as addRequestForQuoteApi } from "@tCooneyBrothers/Services/RequestForQuoteService";
import { CustomApiHandler } from "@tCooneyBrothers/Store/CustomHandlerCreator";

type rfqParameter = {
    rfqForm: RequestForQuoteFormModel;
} & HasOnSuccess;

type HandlerType = CustomApiHandler<rfqParameter, RequestForQuoteFormModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await addRequestForQuoteApi(props.parameter.rfqForm);
};

export const DispatchCustomContactUsFields: HandlerType = props => {
    props.dispatch({
        type: "Data/RequestForQuoteFormFields/fields",
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCustomContactUsFields,
    ExecuteOnSuccessCallback,
];

const addRequestForQuoteFormFields = createHandlerChainRunner(chain, "AddRequestForQuoteFormFields");
export default addRequestForQuoteFormFields;
